module.exports = __webpack_public_path__ + "static/media/light-Creative-demo.d75e4a0e.png";